// @ts-nocheck
/**
 * @generated
 * @file GreenchoiceProjecten (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link GreenchoiceProjecten}
 */
export type GreenchoiceProjectenProps = {
  image1?: string;
  image2?: string;
  link3?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  link4?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  text1?: React.ReactNode;
  text3?: React.ReactNode;
  title1?: React.ReactNode;
  title2?: React.ReactNode;
  title3?: React.ReactNode;
};

/**
 * GreenchoiceProjecten
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function GreenchoiceProjecten({
  image1 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69baaca6512f9a950d1bc11d_kaart_nederland_alle_projecten_1920x1080.webp",
  image2 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69baac9a5baddea5fa020101_kaart_wereld_alle_projecten.webp",

  link3 = {
    href: "/projects?category=ver+weg",
  },

  link4 = {
    href: "/projects?category=dichtbij",
  },

  text1 = "Van nieuwe natuur op voormalige landbouwgrond en natuurherstel in de duinen tot groenere steden en voedselbossen.",
  text3 = "Van het herstellen van mangrovebossen en veengebieden tot het beschermen van regenwoud en aanplanten van nieuwe bossen.",
  title1 = "Ontdek onze natuurprojecten",
  title2 = "In Nederland",
  title3 = "In de rest van de wereld",
}: GreenchoiceProjectenProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"div-block-294"} tag={"div"}>
            <Block className={"div-block-296"} tag={"div"}>
              <Block className={"vertical-flex-greenchoice"} tag={"div"}>
                <Heading className={"h2-greenchoice"} tag={"h2"}>
                  {title1}
                </Heading>
                <Block className={"div-block-301"} tag={"div"}>
                  <Block
                    id={"w-node-b7d6cbe5-4dfd-c83e-9438-c53aa8317903-a83178fb"}
                    tag={"div"}
                  >
                    <Image
                      alt={""}
                      className={"verken-projecten-foto-greenchoice"}
                      height={"auto"}
                      id={
                        "w-node-b7d6cbe5-4dfd-c83e-9438-c53aa8317904-a83178fb"
                      }
                      loading={"lazy"}
                      src={image1}
                      width={"auto"}
                    />
                    <Block className={"vertical-flex-greenchoice"} tag={"div"}>
                      <Heading className={"h3-greenchoice"} tag={"h1"}>
                        {title2}
                      </Heading>
                      <Paragraph className={"text-small-greenchoice"}>
                        {text1}
                      </Paragraph>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"button-greenchoice"}
                        options={link4}
                      >
                        <Block tag={"div"}>
                          {"Bekijk projecten in Nederland"}
                        </Block>
                      </Link>
                    </Block>
                  </Block>
                  <Block
                    id={"w-node-b7d6cbe5-4dfd-c83e-9438-c53aa831790b-a83178fb"}
                    tag={"div"}
                  >
                    <Image
                      alt={""}
                      className={"verken-projecten-foto-greenchoice"}
                      height={"auto"}
                      id={
                        "w-node-b7d6cbe5-4dfd-c83e-9438-c53aa831790c-a83178fb"
                      }
                      loading={"lazy"}
                      src={image2}
                      width={"auto"}
                    />
                    <Block className={"vertical-flex-greenchoice"} tag={"div"}>
                      <Heading className={"h3-greenchoice"} tag={"h1"}>
                        {title3}
                      </Heading>
                      <Paragraph className={"text-small-greenchoice"}>
                        {text3}
                      </Paragraph>
                      <Link
                        block={"inline"}
                        button={false}
                        className={"button-greenchoice"}
                        options={link3}
                      >
                        <Block tag={"div"}>
                          {"Bekijk internationale projecten"}
                        </Block>
                      </Link>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
